module.exports = __webpack_public_path__ + "static/media/light_app.5e5dff42.svg";